import React, { useState, useEffect } from 'react';
import BettingTable from './BettingTable';

export default function BettingOverlay({ 
  show, 
  onClose, 
  symbol, 
  area, 
  lastPrice 
}) {
  const [isClosing, setIsClosing] = useState(false);
  const [mounted, setMounted] = useState(false); // 控制展开动画

  const isUpBet = area === 'green';
  const direction = isUpBet ? 'UP' : 'DOWN';
  const bgColor = isUpBet ? 'bg-green-500/30' : 'bg-red-500/30';
  
  // 关闭动画处理
  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300); // 动画时间
  };
  
  // Handle betting
  const handlePlaceBet = (betData) => {
    console.log('Bet data:', betData);
    // TODO: Add actual betting logic here
    // Such as API calls, confirmation dialogs, etc.
  };
  
  // 监听show变化，重置isClosing状态
  useEffect(() => {
    if (show) {
      setIsClosing(false);
      setMounted(false);
      // 下一帧触发展开动画
      requestAnimationFrame(() => setMounted(true));
    } else {
      setMounted(false);
    }
  }, [show]);
  
  // 动画状态：打开、关闭、正在关闭
  const animationState = isClosing ? 'closing' : (show ? 'opening' : 'closed');
  
  // 使用transform: scaleY实现高性能卷帘动画
  const curtainStyle = {
    transform: (isClosing ? 'scaleY(0)' : (mounted ? 'scaleY(1)' : 'scaleY(0)')),
    transformOrigin: isUpBet ? 'bottom' : 'top',
    transition: 'transform 0.3s cubic-bezier(.4,0,.2,1)'
  };


  // 条件渲染：只有在show或正在关闭时才渲染
  if (!show && !isClosing) {
    return null;
  }

  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center">
      {/* 蒙版背景 */}
      <div 
        className={`absolute inset-0 ${bgColor} backdrop-blur-sm`}
        onClick={handleClose}
        style={curtainStyle}
      />
      
      {/* 下注表格内容 - 与遮罩同步动画 */}
      <div 
        className="relative z-10 w-full max-w-lg mx-auto px-4" 
        onClick={(e) => e.stopPropagation()}
        style={curtainStyle}
      >
        <BettingTable 
          symbol={symbol}
          direction={area}
          lastPrice={lastPrice}
          onClose={handleClose}
        />
      </div>
    </div>
  );
}
